import { render, staticRenderFns } from "./ColumnTreeTableColumn.vue?vue&type=template&id=0281c350&scoped=true"
import script from "./ColumnTreeTableColumn.vue?vue&type=script&lang=js"
export * from "./ColumnTreeTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ColumnTreeTableColumn.vue?vue&type=style&index=0&id=0281c350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281c350",
  null
  
)

export default component.exports